<template>
  <transition name="fade">
    <div v-if="show" id="progress-bar" class="progress-wrapper">
      <div class="progress-indicator-wrapper">
        <div id="nice" :style="'height:' + this.height" class="progress-indicator"></div>
      </div>
      <div class="progress-elements-wrapper">
        <a v-for="element in elements" :id="element.id" :key="element.id" :href="'#'+element.ref" class="element">
          {{ element.name }}
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['elements'],
  data () {
    return {
      show: false,
      height: '0px'
    }
  },
  mounted() {
    window.addEventListener("scroll", this.updateProgressIndicator);
  },
  methods: {
    updateProgressIndicator() {
      const { documentElement, body } = document;
      let windowScroll = body.scrollTop || documentElement.scrollTop;
      let height = documentElement.scrollHeight - documentElement.clientHeight;

      var scrolled = (windowScroll / height) * 100;

      // document.getElementById("nice").style.height = scrolled + "%";
      this.height = scrolled + '%'
      
      // Don't show on first section
      let first_element_top = document.getElementById(this.elements[0].ref).getBoundingClientRect().top
      let first_element_height = document.getElementById(this.elements[0].ref).getBoundingClientRect().height
      
      if (first_element_top <= first_element_height / 2) {
        this.show = true
      }else {
        this.show = false
      }

      for (let element of this.elements) {
        if (document.getElementById(element.ref)) {
          let element_position = document.getElementById(element.ref).getBoundingClientRect()
          if (element_position.top <= document.getElementById(element.ref).getBoundingClientRect().height / 2 & element_position.bottom >= document.getElementById(element.ref).getBoundingClientRect().height / 2) {
            if (element.type == 'dark') {
              document.getElementById('progress-bar').classList.add('dark')
            } else {
              document.getElementById('progress-bar').classList.remove('dark')
            }
          }
        }
      }
    }
  }
}

</script>

<style lang="scss">
.progress-wrapper {
  z-index: 1;
  position: fixed;
  top: calc(50% - 250px);
  left: 30px;

  height: 500px;

  display: flex;

  // .progress-elements-wrapper {
  //   display: flex;
  //   flex-direction: column;
  //   flex-grow: 1;
  //   justify-content: space-around;
  //   .element {
  //     margin: 0 0.7rem;
  //     color: #01262F;
  //     font-size: 1.5vw;
      
  //     &.selected {
  //       color: #FFBD00;
  //       font-weight: bold;
  //       font-size: 1.5vw;
  //     }
  //   }
  // }

  .progress-indicator-wrapper {
    z-index: 1;
    background-color: #01262F;
    height: 100%;
    width: 10px;
    border-radius: 10px;
    .progress-indicator{
        background: #FFBD00;
        position: relative;
        // height: 10%;
    }
  }
}

.progress-wrapper {
  &.dark {
    .progress-elements-wrapper {
      .element {
        color: #fff;

        &.selected {
          color: #FFBD00;
        }
      }
    }
    .progress-indicator-wrapper {
      background-color: #fff;

    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s
}
.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>

